import type { FC } from 'react';

import { ErrorExtension } from '../error-extension';
import Loading from './loading';
import { ReemplaceElement } from './reemplace-element';
import type { TReemplaceElement } from './reemplace-element';

// Type definition for the props accepted by the HoverComponent.
type THoverComponent = {
  isLoading?: boolean; // Boolean flag to indicate if the file upload is in progress.
  isError?: boolean; // Boolean flag to indicate if there's an error in the file upload.
  onClickReset: () => void; // Function to handle reset action.
  onClickRetry: () => void; // Function to handle retry action.
};

// HoverComponent is a functional component that receives props including error, loading, and reset/retry handlers.
export const HoverComponent: FC<THoverComponent & TReemplaceElement> = ({
  isError,
  isLoading,
  fileInputRef,
  handleFileRemove,
  onClickReset,
  onClickRetry,
}) => {
  // If there's an error, show the error extension UI.
  if (isError) {
    return (
      <section className="tw-flex tw-flex-col tw-h-full tw-items-center tw-place-content-center tw-w-full">
        <ErrorExtension
          textDark
          onClickReset={onClickReset}
          onClickRetry={onClickRetry}
        />
      </section>
    );
  }

  // If loading is true, display the loading spinner.
  if (isLoading) {
    return <Loading />;
  }

  // Otherwise, render the file replacement element.
  return (
    <ReemplaceElement
      fileInputRef={fileInputRef} // Pass the file input reference.
      handleFileRemove={e => {
        e.preventDefault(); // Prevent default action for file remove.
        handleFileRemove(e); // Call the handleFileRemove function passed in props.
      }}
    />
  );
};
